import * as yup from "yup";

const departmentValidation = yup.object().shape({
  name: yup.string().required("Bu alan zorunludur"),
});

export default departmentValidation;
